import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export default {
    unsubscribe: (code: string) =>
        fetch(`${PURCHASER_API_BASE_URL}/unsubscribe`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify({ code }),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Invalid code to unsubscribe.");
            }
            return res.json();
        }),
};
